// Models
import { ICustomerAddress } from '@core/models-v2/customer/customer.interface';
import { AddressOption } from '../models/address-option.type';

/**
 * Obtiene las opciones de dirección del cliente.
 * @param addresses - Direcciones del cliente.
 * @param selectedAddressId - Id de la dirección seleccionada.
 * @returns Opciones de dirección.
 */
export const getAddressOptions = (
  addresses: ICustomerAddress[],
  selectedAddressId: string
): AddressOption[] => {
  return addresses.map((address) => {
    const isDefault = address.id === selectedAddressId;
    const baseAddress = `${address.street} ${address.number},`;
    // departmentHouse o departmentOrHouse
    const fullAddress = address.departmentHouse
      ? `${baseAddress} depto/casa: ${address.departmentHouse}, ${address.city}`
      : `${baseAddress} ${address.city}`;
    return { ...address, fullAddress, isDefault };
  });
};
